module.exports = __webpack_public_path__ + "img/mpa_c_v_9160.a9cb1a57.jpg";